const CampaignProgramEnum = Object.freeze({
    BMW: [
        "d3a45b49-4387-4221-9055-24db52bf2368",
        "b257486d-9b9a-46f6-85fd-601c452f7983",
        "37ec98e2-c9e3-4a62-8e96-c883c3b91bed",
        "eaed72e0-77a8-11ee-b962-0242ac120002",
    ],
    NISSAN_UPGRADE_ROOT: ["3241a4be-7ad0-4c89-90b3-71ee90bbc53a"], // Nissan Upgrade Root Site
});
export default CampaignProgramEnum;
